import SDAdaptiveOptions from '@/shared/components/SDComponentsNewDesign/SDAdaptiveOptions/SDAdaptiveOptions'
import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import { mandatoryTag } from '@/containers/SubscriptionFormPageNew/isMandatory'
import getError from '@/containers/SubscriptionFormPageNew/getError'

const TenantType = () => {
  const { tenantTypeOptionsArray, updateAddress, errors, t, tenantType, optionalResidenceFields } = useAddress()

  if (!tenantTypeOptionsArray.length) return null

  return (
    <SDAdaptiveOptions
      label={(optionalResidenceFields ? '' : mandatoryTag) + t('subscriptionForm:address_module.tenant_type')}
      options={tenantTypeOptionsArray}
      selectedValue={tenantType ?? ''}
      onChangeHandler={value => updateAddress({ tenantType: value })}
      error={getError('tenantType', errors)}
    />
  )
}

export default TenantType
